import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ShoppingCartService } from '@services/shopping-cart.service';
import { Fade } from '@util/animations';

import { CurrentUser } from '@models/user';
import { QueryReloaderService } from '@services/query-reloader.service';
import { OverlayToggleComponent } from '../overlay-toggle/overlay-toggle.component';

@Component({
  selector: 'vnm-shopping-cart-toggle',
  templateUrl: './shopping-cart-toggle.component.html',
  styleUrls: ['./shopping-cart-toggle.component.scss'],
  animations: [Fade]
})
export class ShoppingCartToggleComponent implements OnChanges {
  @ViewChild('cartToggle') cartToggle: OverlayToggleComponent;

  @Input() currentUser!: CurrentUser;
  @Input() buttonClass: string;
  @Input() label = 'shopping-cart-toggle.label';
  @Input() icon = 'shopping-cart';
  @Input() iconOnly = false;

  buttonLabel = this.label;
  faIcon = `fa fa-fw fa-${this.icon}`;

  shoppingCart$ = this.shoppingCartService.shoppingCart$;

  constructor(private shoppingCartService: ShoppingCartService, private reloaderService: QueryReloaderService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.iconOnly) {
      this.buttonLabel = this.iconOnly ? '' : this.label;
    }

    if (changes.icon) {
      this.faIcon = `fa fa-fw fa-${this.icon}`;
    }
  }

  onDismiss() {
    this.reloaderService.reloadQueriesLike(/LoadShoppingCart/);
  }
}
